/**
 * Opens a new window with a printable QR code
 * @param qrCodeSvg - The QR code SVG element as a string
 * @returns true if the window was opened successfully, false otherwise
 */
export const printCheckupQRCode = (qrCodeSvg: string): boolean => {
  // The overrides for @media print are because otherwise the body's min-height of 100vh plus the padding means the
  // viewport extends beyond the page so browsers want to print a 2nd, blank page. Note that even with the print
  // overrides it wanted to print a 2nd page unless we set the body padding to 0 in the non-override. That's fine because
  // everything is centered so the margin doesn't matter anyway.
  const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Print QR Code</title>
        <style>
          @media print {
            @page {
              margin: 1cm;
            }
            body {
              display: block;
              margin: 0;
              min-height: 0;
              padding: 0;
            }
            .qr-container {
              text-align: center;
              margin: 0 auto;
            }
          }
          body {
            font-family: Arial, sans-serif;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 100vh;
            margin: 0;
          }
          .qr-container {
            text-align: center;
          }
          .qr-container svg {
            background-color: white;
            padding: 10px;
            border: 1px solid #e0e0e0;
          }
          .instruction-text {
            margin-top: 30px;
            font-size: 18px;
            max-width: 400px;
            text-align: center;
          }
        </style>
      </head>
      <body>
        <div class="qr-container">
          ${qrCodeSvg}
          <div class="instruction-text">
            Scan the QR code, follow the instructions to take a video of your dog.
          </div>
        </div>
        <script>
          // Trigger print dialog after page loads
          window.addEventListener('load', () => {
            setTimeout(() => {
              window.print();
            }, 100);
          });
        </script>
      </body>
    </html>
  `;

  // Create a blob URL with the HTML content
  const blob = new Blob([htmlContent], { type: 'text/html' });
  const blobUrl = URL.createObjectURL(blob);

  // Open the blob URL in a new window
  const printWindow = window.open(blobUrl, '_blank');

  if (!printWindow) {
    URL.revokeObjectURL(blobUrl);
    return false;
  }

  // Clean up the blob URL after the window loads
  printWindow.addEventListener('load', () => {
    URL.revokeObjectURL(blobUrl);
  });

  return true;
};
